import { useAppDispatch, useAppSelector } from "../../../store";
import { BlockAddress } from "../../output/types";
import { useRenderCache } from "../../renderer/hooks";
import { uiActions } from "../slice";
import { ResourceView } from "../../resources/components/ResourceView";

export const Preview = () => {

  const previewResource = useAppSelector(state => state.ui.currentPreviewResource);
  const render = useRenderCache();
  const rendered = render(previewResource);
  const dispatch = useAppDispatch();

  const handleLineClick = (block: number) => (group: number) => (line: number) => {
    const address: BlockAddress = { block, group, line };
    dispatch(uiActions.setCurrentPreviewResource(null));
    // Be sure to pass the original pre-rendered resource to setCurrentLiveResource
    // - it will grab the rendered copy from the cache, but needs the original to
    // correctly open the resource editor.
    dispatch(uiActions.setCurrentLiveResource({
      resource: previewResource!,
      annotations: previewResource!.annotations,
      blockAddress: address
    }));
  };

  const handleEditClick = () => {
    if (previewResource) {
      // Be sure to edit the _original_ resource from resources state, and not
      // the one from the render cache!
      dispatch(uiActions.setCurrentModal({
        modal: 'resourceEditor',
        payload: previewResource
      }));
    }
  };

  return (
    <ResourceView
      onEdit={handleEditClick}
      onLineClick={handleLineClick}
      resource={rendered}
    />
  );

};
